/*
Dilip 03/23/2023 2699762545 added prior letter table
Prakash 03/24/2023 2699762545 Removed Button above spacing.
Dilip 03/24/2023 2699762545 added prior letter payload
Sohel 03/27/2023 2699762545 Payload Changes
Dilip 03/27/2023 2699762545 added bredcrums to show code and description
Akhila 03/27/2023 2699762545 Added save button
Prakash 03/27/2023 2699762545 Added class name for table.
Sohel 03/29/2023 2699762545 Rename prior letters label
Sohel 03/30/2023 2699762545 Change letter Type Value
Guru Prasad 04/11/2023 2699762545 Fixed alignments
Ravi 04/12/2023 2699762545 Added unsaved popup changes
Akhila 05/24/2024 2699762545 role access implemeneted
Ravi 06/20/2023 2699762545 Added Breadcrum in popup
Ravi 06/21/2023 2699762545 fixed submit issue
Sohel 11/11/2023 2699762545 Fixed PriorLetters Save and Letter Type Pre populate Issue
*/
import React, {useState, useRef, useEffect} from 'react';
import {Formik, FieldArray, Field, Form} from 'formik';
import {Button} from '@material-ui/core';
import reusableInputStyles from '../../../components/InputStyles';
import DialogBox from '../../../components/DialogBox';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {Add} from '@material-ui/icons';
import LetterMaintenanceSearchTable from '../SearchLetterMaintenance';
import PriorLettersTable from './PriorLetters/PriorLettersTable';
import {
  postPriorLetterInformation,
  fetchPriorLettersData,
  resetBasicInfo,
} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import BreadCrums from '../../../util/BreadCrum';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

export const PriorLetters = ({
  handleBack,
  handleNext,
  handleDirty,
  LetterMainAccess,
  editExisting,
}) => {
  const {
    letterCode,
    isBasicInfoLoading,
    basicInfoSuccessMsg,
    basicInfoErrorMsg,
    basicInfoStatus,
    priorLetterData,
    basicInfoData,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const initialState = {
    priorLetters: [],
  };
  const [initialValues, setInitialValues] = useState(initialState);
  const [lettersDeletedIds, setLettersDeletedIds] = useState([]);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [isPrior, setIsPrior] = useState(false);
  const priorArrayHelpers = useRef();
  const formRef = useRef();
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const saveRef = useRef();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Letter Code',
    },
    {
      title: 'Letter Description',
    },
  ];

  useEffect(() => {
    const priorLettersData =
      priorLetterData?.priorLetterRequests?.length > 0 ?
        priorLetterData?.priorLetterRequests?.map((el) => {
          return {
            ...el,
            letterCode: el?.previousLetterCode,
            letterDescription: el?.previousLetterDesc,
          };
        }) :
        [];
    setInitialValues({
      ...initialValues,
      priorLetters: priorLettersData,
    });
  }, [priorLetterData]);

  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const priorLetters =
      values?.priorLetters?.length > 0 ?
        values?.priorLetters?.map((el) => {
          return {
            precedingLetterId: el?.precedingLetterId ? el?.precedingLetterId : 0,
            previousLetterCode: el?.letterCode,
            previousLetterDesc: el?.letterDescription,
          };
        }) :
        [];
    const payload = {
      deletePriorIds: lettersDeletedIds?.length > 0 ? [...new Set(lettersDeletedIds)] : [0],
      letterCode: letterCode,
      isDraft: basicInfoData?.isDraft === 'N' ? 'N' : 'Y',
      lastStep: 4,
      priorLetterRequests: priorLetters,
    };
    dispatch(postPriorLetterInformation(payload));
  };

  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
        if (basicInfoSuccessMsg && basicInfoStatus === 200 && !saveRef.current) {
          handleNext();
        } else if (basicInfoSuccessMsg && basicInfoStatus === 200 && saveRef.current) {
          dispatch(fetchPriorLettersData(letterCode));
        }
      }, 2000);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg, basicInfoStatus]);

  useEffect(() => {
    if (letterCode) {
      dispatch(fetchPriorLettersData(letterCode));
    }
  }, [letterCode]);

  const handlePriorClose = () => {
    setIsPrior(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
        innerRef={formRef}
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              <Form noValidate>
                <div>
                  <FieldArray
                    name="priorLetters"
                    render={(arrayHelpers) => {
                      priorArrayHelpers.current = arrayHelpers;
                      return (
                        <>
                          <div className="table-header justify-content-between new-standard-textfields">
                            <div>
                              <BreadCrums
                                name={'Letter Code'}
                                code={basicInfoData?.letterCode}
                                description={'Letter Description'}
                                descriptionValue={basicInfoData?.letterDescription}
                              />
                            </div>
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              disabled={editExisting && !LetterMainAccess?.edit}
                              onClick={() => {
                                setIsPrior(true);
                              }}
                              startIcon={<Add />}
                            >
                              Prerequisite
                            </Button>
                          </div>
                          <div
                            className={
                              'mui-custom-table-container custom-table new-standard-textfields pt-0 global-field-table text-center-table'
                            }
                          >
                            <table>
                              <thead className="recFormat-header-container">
                                <tr>
                                  {columns.map(
                                    ({title, hidden = false}) =>
                                      !hidden && (
                                        <th key={title} className="recFormat-header">
                                          {title}
                                        </th>
                                      ),
                                  )}
                                </tr>
                              </thead>
                              {values.priorLetters?.length > 0 ? (
                                <tbody className="recFormat-body">
                                  {values.priorLetters.map((field, index) => (
                                    <>
                                      <Field
                                        key={field.letterCode}
                                        name={`priorLetters[${index}]`}
                                        component={PriorLettersTable}
                                        index={index}
                                        columns={columns}
                                        priorArrayHelpers={priorArrayHelpers}
                                        lettersDeletedIds={lettersDeletedIds}
                                        setLettersDeletedIds={setLettersDeletedIds}
                                        LetterMainAccess={LetterMainAccess}
                                        editExisting={editExisting}
                                      />
                                    </>
                                  ))}
                                </tbody>
                              ) : (
                                <tbody>
                                  <tr>
                                    <td colSpan={columns.length}>{'No records to display'}</td>
                                  </tr>
                                </tbody>
                              )}
                            </table>
                          </div>
                          <DialogBox
                            open={isPrior}
                            dialogClose={handlePriorClose}
                            // title={"Search Prerequisite"}
                            title={
                              <div className="dialog-breadcrum">
                                <p className="dialoge-title-breadcrum">
                                  <b>Search Prerequisite</b>
                                </p>
                                <BreadCrums
                                  name={'Letter Code'}
                                  code={basicInfoData?.letterCode}
                                  description={'Letter Description'}
                                  descriptionValue={basicInfoData?.letterDescription}
                                />
                              </div>
                            }
                            maxWidth="xl"
                          >
                            <LetterMaintenanceSearchTable
                              isPriorLetters={true}
                              lettersValues={values}
                              setTempSelectedRows={setTempSelectedRows}
                              tempSelectedRows={tempSelectedRows}
                              handlePriorClose={handlePriorClose}
                              setLettersValues={setFieldValue}
                              lettersDeletedIds={lettersDeletedIds}
                              setLettersDeletedIds={setLettersDeletedIds}
                              letterType={basicInfoData?.letterType}
                            />
                          </DialogBox>
                        </>
                      );
                    }}
                  />
                </div>
                <div className="d-flex justify-content-center mt-3 new-standard-textfields">
                  <Button
                    onClick={() => {
                      handleBack();
                    }}
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {basicInfoData?.isDraft === "N" && ( */}
                  <Button
                    variant="outlined"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                    onClick={() => {
                      handleSubmit(values);
                      saveRef.current = true;
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  <Button
                    variant="outlined"
                    // type="submit"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                    onClick={() => {
                      saveRef.current = false;
                      handleSubmit(values);
                    }}
                  >
                    Save & Next
                  </Button>
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
};
